import './page-scroll.less';

var pageScroll = {
	'id': 'page-scroll',
	'hScroll': 0,
	'goTop': function () {
		this.hScroll = $(window).scrollTop();

		$('html, body').animate({
			scrollTop: 0
		}, 200);

		return false;
	},
	'goBottom': function () {
		$('html, body').animate({
			scrollTop: this.hScroll
		}, 200);


		return false;
	},
	'show': function (bottom) {
		if (bottom) {
			$("#" + this.id).addClass('scroll-bottom');
		} else {
			$("#" + this.id).removeClass('scroll-bottom');
		}

		$("#" + this.id).fadeIn("fast");
	},
	'hide': function () {
		$("#" + this.id).fadeOut("fast")
	}
};

var siteHeader = {
	'isFix': false,
	'topFix': '250',
	'fix': function () {
		if (this.isFix) {
			return false;
		}

		this.isFix = true;

		var header = $('#page-scroll-header');

		$(header).find('.container').prepend($('#mmenu .main'))
		$(header).show();
		$(header).animate({
			"top": "+=41px"
		}, "fast");
	},
	'unfix': function () {
		if (!this.isFix) {
			return false;
		}

		this.isFix = false;

		var header = $('#page-scroll-header');

		$('#mmenu').prepend($(header).find('.main'))

		$(header).animate({
			"top": "-=41px"
		}, "fast", function () {
			$(header).hide();
		});
	},
	'fixSize': function () {
		if (!this.isFix) {
			return false;
		}
	}
};

var layoutWidth = $('#page-layout').width();
var screenHeight = $(window).height();

if ($(window).scrollTop() > siteHeader.topFix && layoutWidth > 1024 && window.location.pathname != '/cart/') {
	siteHeader.fix();
}


$(window).resize(function () {
	siteHeader.fixSize();
});

$(window).scroll(function () {
	if (layoutWidth > 1024 && window.location.pathname != '/cart/') {
		if ($(window).scrollTop() > siteHeader.topFix) {
			siteHeader.fix();
		}

		if ($(window).scrollTop() < siteHeader.topFix) {
			siteHeader.unfix();
		}
	}

	if ($(window).scrollTop() > screenHeight / 1.5) {
		pageScroll.show(false);
	} else {
		if (pageScroll.hScroll) {
			pageScroll.show(true);
		} else {
			pageScroll.hide();
		}
	}

	if ($('html').scrollTop() >= 250) {
		$('#page-header').css('paddingBottom', '61px');
		if (window.location.pathname == '/cart/') {
			$('.second-line-header-alert').addClass('fixed--cart');
		} else {
			$('.second-line-header-alert').addClass('fixed');
		}
	} else {
		$('.second-line-header-alert').removeClass('fixed');
		$('.second-line-header-alert').removeClass('fixed--cart');
		$('#page-header').css('paddingBottom', '0');
	}

});

$("#" + pageScroll.id).click(function () {
	if ($(window).scrollTop() > screenHeight / 1.5) {
		pageScroll.goTop();
	} else {
		pageScroll.goBottom();
	}
});